import { InlineNotification } from "carbon-components-react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateDonationNotificationStatus } from "../../actions/donationNotifications";
import { getDonationNotificationStatus, getDonationNotificationTeamName } from "../../selectors";

const DonationNotification = () => {
  const dispatch = useDispatch();

  const teamName = useSelector(getDonationNotificationTeamName);
  const donationNotificationStatus = useSelector(getDonationNotificationStatus);

  if (donationNotificationStatus !== "open") {
    return null;
  }

  return (
    <InlineNotification
      kind="info"
      lowContrast={true}
      title={`A donation to team ${teamName} was successfully submitted.`}
      timeout={5}
      onClose={() => dispatch(updateDonationNotificationStatus("closed"))}
    />
  );
};

export default DonationNotification;
